module.exports = __webpack_public_path__ + "img/footer-logo-2.3e8a7502.png";